import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { exportCzechSuklRsAtcGroups } from '~/libs/infrastructure/api/availability';
import { handleError } from '~/ErrorHandler';
import downloadBlobFile from '~/utils/Download/downloadBlobFile';
import type { ThunkDispatch } from '~/Store';

export function useAvailabilityExport() {
	const dispatch: ThunkDispatch<AnyAction> = useDispatch();
	const mutation = useMutation({
		mutationFn: (ids: string[]) => exportCzechSuklRsAtcGroups(ids),
	});

	async function triggerExport(ids: string[]) {
		try {
			const { blob, filename } = await mutation.mutateAsync(ids);
			downloadBlobFile(blob, filename);
		} catch (error: unknown) {
			dispatch(handleError(error));
		}
	}

	return { triggerExport, isExporting: mutation.isLoading };
}
